import _ from "lodash";

export default {
    data() {
        return {
            component: [],
            isEditing: false,
            array: [],
            isClone: false,
        }
    },
    methods: {
        clone(array) {
            this.array = array;
            const component = _.cloneDeep(array);
            this.component = component;
        },
        edit() {
            this.isEditing = true;
        },
        save() {
            this.$emit('save', this.component);
            this.isEditing = false;
        },
        cancel() {
            this.clone(this.obj);
            this.isEditing = false;
        }

    },
    watch: {
        component: {
            deep: true,
            handler(newValue, oldValue) {
                if (oldValue.length || newValue.length === 0) {
                    this.$emit('update', this.component);
                }
            }
        }
    }
}